<template>
  <div class="modal" v-if="isVisible" :data-insere="codigoRoteiro">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button id="fechar" type="button" class="btn btn-danger" style="margin-left:auto" @click="closeModal2">
            DESISTIR X
          </button>
          <h5 class="modal-title py-3">Formulário (Agendamento)</h5>
          <span>E-mail do responsável: {{ formData.email }}</span>
        </div>
        <div class="modal-body">
          <form @submit.prevent="submitForm">
            <input type="hidden" readonly v-model="formData.id" />
            <label for="instituicao">
              <b> Nome da instituição: </b>
            </label>
            <input type="text" id="instituicao" v-model="formData.instituicao" placeholder="Digite aqui o nome da instituição" required />
            <label for="nomecontato">
              <b> Nome do responsável: </b>
            </label>
            <input type="text" id="nomecontato" name="nomecontato" v-model="formData.nomecontato" placeholder="Nome do responsável">
            <label for="cargo">
              <b> Cargo: </b>
            </label>
            <input type="text" id="cargo" name="cargo" v-model="formData.cargo" placeholder="Cargo do responsável">
            <label for="obs">
              <b> Informações de contato: </b>
            </label>
            <div class="d-flex gap-4">
              <input type="checkbox" id="agenciaCheck" v-model="isAgencia" />
              <label for="agenciaCheck">Você é uma agência? Se sim, marque este campo.</label>
            </div>
            <input type="text" id="obs" v-model="formData.obs" :placeholder="isAgencia ? 'Telefone da agência com DDD' : 'Telefone do responsável com DDD'" required>
            <label for="cnpj">
              <b> CNPJ da instituição: </b>
            </label>
            <input type="text" @blur="checaCNPJ" id="cnpj" v-model="formData.cnpj" placeholder="Digite aqui o CNPJ" required />
            <p class="irregular" v-if="cnpjInvalido">CNPJ inválido, continue editando até esta mensagem desaparecer</p>
            <label for="tipo">
              <b> Tipo de instituição: </b>
            </label>
            <select name="tipo" id="tipo" v-model="formData.tipo" required>
              <option value="Escola Particular">Escola Particular</option>
              <option value="Escola Municipal">Escola Municipal</option>
              <option value="Escola Estadual">Escola Estadual</option>
              <option value="Ong (Organização não governamental)">Ong (Organização não governamental)</option>
              <option value="Empresa">Empresa</option>
              <option value="Universidade Pública">Universidade Pública</option>
              <option value="Universidade Privada">Universidade Privada</option>
              <option value="Outros tipos (Lar de idosos, Cursinho)">Outros tipos (Lar de idosos, Cursinho)</option>
            </select>
            <label for="endereco">
              <b> Endereço da Instituição: </b>
            </label>
            <input type="text" id="endereco" v-model="formData.endereco" placeholder="Digite aqui o endereço" required />
            <label for="quantidade">
              <b> Quantidade máxima para este roteiro é {{ maximo }} </b>
              <br /><br />
              A cada grupo de 20, 1 pessoa é responsável. Exemplo: em um grupo é de 20 pessoas, 19 são alunos e 1 é professor(a)
            </label>
            <input type="number" id="quantidade" v-model="formData.quantidade" min="20" :max="maximo" placeholder="Digite aqui a quantidade" required />
            <label for="serie">
              <b> Série/Faixa Etária </b>
            </label>
            <div class="d-flex gap-3 flex-column">
              <!-- Opções de séries -->
              <!-- ... -->
              <DeficienciaForm @update:deficiencias="handleDeficienciasUpdate" />
            </div>
            <!-- Outros campos do formulário -->
            <div class="d-flex">
              <input type="checkbox" name="ciente" id="ciente" v-model="isChecked" />
              <label for="ciente">Ciente que aos finais de semana, feriados, emendas de feriados e período de férias: não haverá monitoria, sendo a visitação livre.</label>
            </div>
            <div class="d-flex">
              <input type="checkbox" name="ciente2" id="ciente2" v-model="isChecked2" />
              <label for="ciente2">Confirme ter lido todas as instruções da tela inicial, principalmente o limite mínimo de idade para cada roteiro.</label>
            </div>
            <button type="submit" class="btn btn-primary" :disabled="!isChecked || !isChecked2 || isSubmitting">
              Enviar
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watchEffect, watch, computed } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { getCurrentUser } from "@/services/authService";
import DeficienciaForm from './DeficienciaForm.vue';

export default {
  components: {
    DeficienciaForm
  },
  props: {
    isVisible: Boolean,
    codigoRoteiro: String,
    diaselecionado: String,
    horarioselecionado: String,
    codigodisplay: String,
  },
  setup(props, { emit }) {
    const deficienciasRecebidas = ref([]);
    const handleDeficienciasUpdate = (deficiencias) => {
      deficienciasRecebidas.value = deficiencias;
    };

    const isChecked = ref(false);
    const isChecked2 = ref(false);
    const isAdmin = ref(getCurrentUser() === 'admin.agendamento@cataventomaster.com' ? true : false);
    const cnpjInvalido = ref(false);
    const isAgencia = ref(false);
    const isSubmitting = ref(false);
    const router = useRouter();
    const maximo = ref("");
    const formData = ref({
      cnpj: "",
      agencia: ref(''),
      nomecontato: "",
      cargo: "",
      deficiencia: [],
      email: getCurrentUser(),
      endereco: "",
      id: "",
      quantidade: "",
      series: [],
      obs: "",
      tipo: "",
      diamaster: "",
      aprovacao: "pendente",
    });
    const infodia = ref("");

    watch(() => formData.value.obs, (novoTelefone) => {
      let value = novoTelefone.replace(/\D/g, ""); // Remove caracteres não numéricos
      if (value.length > 11) {
        value = value.slice(0, 11); // Limita a 11 caracteres, adequado para celulares no Brasil
      }
      value = value.replace(/^(\d{2})(\d)/, "($1) $2"); // Insere o DDD entre parênteses
      value = value.replace(/(\d{5})(\d)/, "$1-$2"); // Insere o hífen entre o quinto e sexto dígitos
      formData.value.obs = value; // Atualiza o valor formatado

      if (novoTelefone === "") {
        // Aqui você pode adicionar qualquer lógica adicional necessária para quando o campo estiver vazio
      } else {
        // Aqui você pode adicionar qualquer lógica de validação do número de telefone, se necessário
      }
    });

    watch(() => formData.value.cnpj, (novoCNPJ) => {
      let value = novoCNPJ.replace(/\D/g, ""); // Remove caracteres não numéricos
      if (value.length > 14) {
        value = value.slice(0, 14); // Limita a 14 caracteres
      }
      value = value.replace(/^(\d{2})(\d)/, "$1.$2");
      value = value.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
      value = value.replace(/\.(\d{3})(\d)/, ".$1/$2");
      value = value.replace(/(\d{4})(\d)/, "$1-$2");
      formData.value.cnpj = value; // Atualiza o valor formatado

      if (novoCNPJ === "") {
        cnpjInvalido.value = false;
      } else {
        checaCNPJ();
      }
    });

    const defineMax = (param) => {
      if (param === "01" || param === "11") {
        maximo.value = 48;
      } else if (param === "02" || param === "03") {
        maximo.value = 44;
      } else if (param === "04") {
        maximo.value = 42;
      } else if (param === "05" || param === "08" || param === "09" || param === "10") {
        maximo.value = 40;
      } else if (param === "07" || param === "13" || param === "15" || param === "16") {
        maximo.value = 50;
      } else if (param === "06" || param === "12") {
        maximo.value = 60;
      } else if (param === "14") {
        maximo.value = 46;
      } else {
        maximo.value = 46;
      }
    };

    const regexDia = (input) => {
      if (input.endsWith("f") || /14$/.test(input)) {
        const regex = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        const formatted = input.replace(regex, "Roteiro Livre | $4h$5 | $3/$2/$1");
        const formatted2 = input.replace(regex, "$1-$2-$3");
        const maxcross = input.replace(regex, "$7");
        defineMax(maxcross);
        infodia.value = formatted;
        formData.value.diamaster = formatted2;
      } else {
        const regex = /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;
        const formatted = input.replace(regex, "Roteiro $7 | $4h$5 | $3/$2/$1");
        const formatted2 = input.replace(regex, "$1-$2-$3");
        const maxcross = input.replace(regex, "$7");
        defineMax(maxcross);
        infodia.value = formatted;
        formData.value.diamaster = formatted2;
      }
    };

    watchEffect(() => {
      formData.value.agencia = isAgencia.value ? 'É uma agência' : 'Não é uma agência';
      regexDia(props.codigodisplay);
      formData.value.id = props.codigodisplay;
    });

    const closeModal = () => {
      emit("close");
    };

    const closeModal2 = () => {
      addId();
      emit("close");
    };

    const id = computed(() => {
      return props.codigodisplay;
    });

    const acao = ref('remover');

    const addId = async () => {
      try {
        const response = await axios.post('https://museucatavento.org.br/sistema-agendamento/verificaid.php', `id=${id.value}&acao=${acao.value}`, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        console.log(response.data.message);
        if (response.data.success) {
          id.value = '';
        }
      } catch (error) {
        console.error('Erro ao adicionar ID:', error);
      }
    };

    const submitForm = async () => {
      if (isSubmitting.value) {
        return;
      }

      isSubmitting.value = true;
      formData.value.deficiencia = deficienciasRecebidas.value;

      if (cnpjInvalido.value) {
        alert("Por favor, insira um CNPJ válido.");
        isSubmitting.value = false;
        return;
      }

      try {
        const response = await axios.post("https://museucatavento.org.br/sistema-agendamento/api.php", formData.value, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        console.log(response.data);
        alert(response.data);
        closeModal();
        router.push("/registros");
      } catch (error) {
        alert(error);
      } finally {
        isSubmitting.value = false;
      }
    };

    function checaCNPJ() {
      cnpjInvalido.value = !validaCNPJ(formData.value.cnpj);
    }

    function validaCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, "");

      if (cnpj === "") return false;
      if (cnpj.length !== 14) return false;

      if (/^(\d)\1+$/.test(cnpj)) return false;

      let tamanho = cnpj.length - 2;
      let numeros = cnpj.substring(0, tamanho);
      let digitos = cnpj.substring(tamanho);
      let soma = 0;
      let pos = tamanho - 7;

      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(0)) return false;

      tamanho = tamanho + 1;
      numeros = cnpj.substring(0, tamanho);
      soma = 0;
      pos = tamanho - 7;
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) pos = 9;
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
      if (resultado != digitos.charAt(1)) return false;

      return true;
    }

    return {
      cnpjInvalido,
      isChecked,
      isChecked2,
      isAdmin,
      addId,
      id,
      acao,
      checaCNPJ,
      infodia,
      formData,
      maximo,
      closeModal,
      closeModal2,
      submitForm,
      isAgencia,
      handleDeficienciasUpdate,
      isSubmitting,
    };
  },
};
</script>

<style scoped>
.modal {
  display: flex;
  justify-content: center;
  align-items: start;
  position: fixed;
  z-index: 1050;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  outline: 0;
  background-color: rgba(0, 0, 0, 0.5);
  overflow-y: auto;
  padding: 1rem;
}

.modal-dialog {
  position: relative;
  width: min(920px, 100%);
  margin: 1rem auto;
  pointer-events: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid var(--catavento-border, #d9e1ea);
  border-radius: var(--catavento-radius, 8px);
  box-shadow: var(--catavento-shadow, 0 10px 28px rgba(20, 30, 45, 0.12));
  outline: 0;
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
  padding: 1.25rem;
  border-bottom: 1px solid var(--catavento-border, #d9e1ea);
  gap: 0.5rem;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.25rem;
  text-align: left;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}

form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.irregular {
  background: #c24a4a;
  color: white;
  border: 0;
  border-radius: 6px;
  padding: 0.65rem 0.75rem;
}

h6 {
  padding: 20px;
  margin: 20px 0px;
  border: 1px solid black;
}

@media (max-width: 767px) {
  .modal {
    padding: 0.5rem;
  }

  .modal-dialog {
    margin: 0.5rem auto;
  }

  .modal-header,
  .modal-body {
    padding: 1rem;
  }

  #fechar,
  button[type="submit"] {
    width: 100%;
  }
}
</style>
